import React, { useEffect, useState } from "react"
import { ArrowLeftOutlined } from "@ant-design/icons";
import { Button, Col, Row, Select, Spin, Input } from "antd";
import { t } from "i18next";
import { useParams, useNavigate } from "react-router-dom";
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import {
   getParents,
   getSubModuleById,
   updatePerformanceModuleById,
   createPerformanceModuleById
} from "services/performance_module";
import {
   NumberInput,
   SelectInput
} from "common/elements";

export default function InsertAndUpdateForm() {
   const { id, parentId } = useParams();
   const [loading, setLoading] = useState(false)
   const [loadingBtn, setLoadingBtn] = useState(false)
   const [datas, setDatas] = useState({
      parentId: parseInt(parentId),
      level: 1,
      title: "",
      defaultDescription: "",
      action1: "",
      action2: "",
      action3: "",
      action4: "",
      reportable: 0,
      inputType: null,
      layout: undefined,
      numRow: 0,
      order: null
   });
   const [parentModules, setParentModules] = useState([]);

   const navigate = useNavigate();

   const onBack = () => {
      navigate(-1)
   }

   useEffect(() => {
      setLoading(true)
      getParents(parentId)
      .then((response) => {
         if (response) {
            setParentModules(response.data)
         }
      })
      .finally(() => setLoading(false));

      if (JSON.parse(id)) {
         getSubModuleById(id).then((response) => {
            if (response) {
               const data = {
                  parentId: response.data.parentId,
                  level: response.data.level,
                  reportable: response.data.reportable,
                  title: response.data.title ? response.data.title : "",
                  defaultDescription: response.data.defaultDescription,
                  action1: response.data.action1 ? response.data.action1 : "",
                  action2: response.data.action2 ? response.data.action2 : "",
                  action3: response.data.action3 ? response.data.action3 : "",
                  action4: response.data.action4 ? response.data.action4 : "",
                  inputType: response.data.inputType,
                  layout: response.data.layout,
                  numRow: response.data.numRow,
                  enableMultiRow: response.data.enableMultiRow,
                  order: response.data.order
               }
               setDatas({ ...data })
            }
         });
      }
      // eslint-disable-next-line
   }, []);

   const onSubmit = () => {
      setLoadingBtn(true)
      if (JSON.parse(id)) {
         updatePerformanceModuleById(id, datas).then(() => {
            onBack()
         }).finally(() => setLoadingBtn(false))
      } else {
         createPerformanceModuleById(datas).then(() => {
            onBack()
         }).finally(() => setLoadingBtn(false))
      }
   }

   const onChangeParentModule = (option) => {
      if (option) {
         datas["parentId"] = option.value;
         datas["level"] = parseInt(option.children[1].props.children) + 1;
      } else {
         datas["parentId"] = parseInt(parentId);
         datas["level"] = 1;
      }
      setDatas({ ...datas })
   }

   const onChangeDescription = (event) => {
      datas["defaultDescription"] = event.target.value;
      setDatas({ ...datas })
   }

   const onChangeEnableMultiRow = (value) => {
      datas["enableMultiRow"] = value;
      setDatas({ ...datas })
   }

   const onChangeReportable = (value) => {
      datas["reportable"] = value;
      setDatas({ ...datas })
   }

   const onChangeInputType = (value) => {
      datas["inputType"] = value;
      setDatas({ ...datas });
   }

   const onChangeLayout = (value) => {
      datas["layout"] = value;
      setDatas({ ...datas });
   }

   const onChangeCKEditor = (key, editor) => {
      const data = editor.getData();
      datas[key] = data;
   }

   const onChangeOrder = (value) => {
      datas["order"] = value;
      setDatas({ ...datas })
   }

   const onChangeNumRow = (value) => {
      datas["numRow"] = value;
      setDatas({ ...datas })
   }

   return (
      <div style={{ width: "100%", position: "absolute" }}>
         <Row className="btn-navigation">
            <Col span={12}>
               <div className="pull-left">
                  <Button onClick={onBack}>
                     <ArrowLeftOutlined />
                     {t("text_back")}
                  </Button>
                  <span className="title">
                     {JSON.parse(id) ? "Update Performance Module" : "New Performance Module"}
                  </span>
               </div>
            </Col>
            <Col span={12}>
               <div className="pull-right">
                  <Button loading={loadingBtn} onClick={onSubmit}>{t("text_save")}</Button>
               </div>
            </Col>
         </Row>
         <Row style={{ padding: 15, height: "84vh", overflowY: "auto" }}>
            {
               loading ? <Spin spinning={loading} style={{ display: "flex", height: "84vh", justifyContent: 'center', width: "100%", alignItems: "center" }} /> :
                  <>
                     <Col span={24}>
                        <p>Parent Module</p>
                        <Select style={{ width: "100%" }}
                           onChange={(_, option) => onChangeParentModule(option)}
                           allowClear={true}
                           value={datas.parentId}
                        >
                           <Select.Option key={parseInt(parentId)} value={parseInt(parentId)}>
                              <span style={{ display: "none" }}>1</span><span style={{ display: "none" }}>0</span>
                           </Select.Option>
                           {
                              parentModules.map((parentModule) => {
                                 return <React.Fragment key={parentModule.id}>
                                    <Select.Option key={parentModule.id} value={parentModule.id}>
                                       <div dangerouslySetInnerHTML={{ __html: parentModule.title }} /><span style={{ display: "none" }}>1</span>
                                    </Select.Option>
                                    {
                                       parentModule.level2s && parentModule.level2s.map((levelTwo) => {
                                          return <Select.Option key={levelTwo.id} value={levelTwo.id} style={{ marginLeft: 15 }}>
                                             <div dangerouslySetInnerHTML={{ __html: levelTwo.title }} /><span style={{ display: "none" }}>2</span>
                                          </Select.Option>
                                       })
                                    }
                                 </React.Fragment>
                              })
                           }
                        </Select>
                     </Col>
                     <Col span={24} style={{ marginTop: 15 }}>
                        <SelectInput
                           label="Enable Multi Row"
                           valueKey="id"
                           value={datas.enableMultiRow}
                           onChange={onChangeEnableMultiRow}
                           allowClear={true}
                           style={{ width: "100%", margin: 0 }}
                           dataSource={[
                              { id: 0, name: "No" },
                              { id: 1, name: "Yes" }
                           ]}
                        />
                     </Col>
                     <Col span={24} style={{ marginTop: 15 }}>
                        <SelectInput
                           label={"Reportable"}
                           valueKey="id"
                           value={datas.reportable}
                           onChange={onChangeReportable}
                           allowClear={true}
                           style={{ width: "100%", margin: 0 }}
                           dataSource={[
                              { id: 0, name: "No" },
                              { id: 1, name: "Yes" }
                           ]}
                        />
                     </Col>
                     <Col span={24} style={{ marginTop: 15 }}>
                        <p>Title</p>
                        <CKEditor
                           editor={ClassicEditor}
                           data={datas.title}
                           style={{ width: "100%" }}
                           onChange={(event, editor) => onChangeCKEditor("title", editor)}
                        />
                     </Col>
                     <Col span={24} style={{ marginTop: 15 }}>
                        <p>Description</p>
                        <Input.TextArea
                           defaultValue={datas.defaultDescription}
                           rows={5}
                           onChange={(event) => onChangeDescription(event)}
                           style={{margin: 0}}
                        />
                     </Col>
                     <Col span={24} style={{ marginTop: 15 }}>
                        <p>Action 1</p>
                        <CKEditor
                           editor={ClassicEditor}
                           data={datas.action1}
                           style={{ width: "100%" }}
                           onChange={(event, editor) => onChangeCKEditor("action1", editor)}
                        />
                     </Col>
                     <Col span={24} style={{ marginTop: 15 }}>
                        <p>Action 2</p>
                        <CKEditor
                           editor={ClassicEditor}
                           data={datas.action2}
                           style={{ width: "100%" }}
                           onChange={(event, editor) => onChangeCKEditor("action2", editor)}
                        />
                     </Col>
                     <Col span={24} style={{ marginTop: 15 }}>
                        <p>Action 3</p>
                        <CKEditor
                           editor={ClassicEditor}
                           data={datas.action3}
                           style={{ width: "100%" }}
                           onChange={(event, editor) => onChangeCKEditor("action3", editor)}
                        />
                     </Col>
                     <Col span={24} style={{ marginTop: 15 }}>
                        <p>Action 4</p>
                        <CKEditor
                           editor={ClassicEditor}
                           data={datas.action4}
                           style={{ width: "100%" }}
                           onChange={(event, editor) => onChangeCKEditor("action4", editor)}
                        />
                     </Col>
                     <Col span={24} style={{ marginTop: 15 }}>
                        <SelectInput
                           label="Input Type"
                           valueKey="id"
                           value={datas.inputType}
                           onChange={onChangeInputType}
                           allowClear={true}
                           style={{ width: "100%", margin: 0 }}
                           dataSource={[
                              { id: "input", name: "Input Text" },
                              { id: "date", name: "Date Picker" },
                           ]}
                        />
                     </Col>
                     <Col span={24} style={{ marginTop: 15 }}>
                        <SelectInput
                           label={"Layout"}
                           valueKey="id"
                           value={datas.layout}
                           onChange={onChangeLayout}
                           allowClear={true}
                           style={{ width: "100%", margin: 0 }}
                           dataSource={[
                              { id: "horizontal", name: "Horizontal" },
                              { id: "vertical", name: "Vertical" },
                           ]}
                        />
                     </Col>
                     <Col span={24} style={{ marginTop: 15 }}>
                        <NumberInput
                           label={"Number Row"}
                           value={datas.numRow}
                           onChange={(event) => onChangeNumRow(event)}
                           style={{ width: "100%", margin: 0 }}
                        />
                     </Col>
                     <Col span={24} style={{ marginTop: 15 }}>
                        <NumberInput
                           label={"Order"}
                           value={datas.order}
                           onChange={(event) => onChangeOrder(event)}
                           style={{ width: "100%", margin: 0 }}
                        />
                     </Col>
                  </>
            }
         </Row>
      </div>
   )
}
